import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React from "react";

const SectionTab3 = ({
  invoiceData,
  setInvoiceData,
  todayDate,
  accountData,
}) => {
  return (
    <div className="grid grid-cols-12  gap-6 w-full mt-3">
      <div className="col-span-12 md:col-span-6 space-y-6 border-2 border-blue-400 p-4 rounded-lg bg-white">
        <div>
          <div className="space-y-4 flex items-center justify-between">
            <FormControl component="fieldset">
              <FormLabel component="legend" className="text-sm text-gray-700">
                Delivery Type
              </FormLabel>
              <RadioGroup
                row
                name="deliveryType"
                value={invoiceData.deliveryType}
                onChange={(e) =>
                  setInvoiceData({
                    ...invoiceData,
                    deliveryType: e.target.value,
                  })
                }
              >
                <FormControlLabel
                  value="CUST_COLLECT"
                  control={<Radio size="small" />}
                  label="Cust. Collect"
                />
                <FormControlLabel
                  value="DELIVERY"
                  control={<Radio size="small" />}
                  label="Delivery"
                />
              </RadioGroup>
            </FormControl>
            <div className="flex flex-col text-sm">
              <label className="mb-1 font-medium text-gray-700">
                Prom.Date
              </label>
              <input
                type="date"
                value={todayDate}
                className="px-3 py-2  border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <TextField
            label="Fleet"
            name="fleet"
            fullWidth
            variant="standard"
            size="small"
            autoComplete="off"
          />
          <TextField
            label="GPS Coordinates"
            name="gps"
            fullWidth
            variant="standard"
            size="small"
            autoComplete="off"
          />
          <TextField
            label="MAP-Link"
            name="mapLink"
            fullWidth
            variant="standard"
            size="small"
            autoComplete="off"
          />
        </div>
        {/* Instructions & Driver */}
        <div className=" flex items-center gap-2">
          <TextField
            label="Instructions"
            name="instructions"
            fullWidth
            variant="standard"
            size="small"
            autoComplete="off"
          />
          <div className="flex items-center gap-2">
            <TextField
              label="Driver ID"
              name="driverId"
              fullWidth
              variant="standard"
              size="small"
              autoComplete="off"
              value={invoiceData.drivername}
              onChange={(e) =>
                setInvoiceData({
                  ...invoiceData,
                  drivername: e.target.value,
                })
              }
            />
            <Button variant="contained" size="small" color="primary">
              Show MAP
            </Button>
          </div>
        </div>
      </div>
      <div className="col-span-12 md:col-span-6">
        <TextField
          label="Terms & Conditions"
          name="terms"
          value={
            invoiceData.terms !== undefined && invoiceData.terms !== ""
              ? invoiceData.terms
              : accountData?.terms || ""
          }
          onChange={(e) =>
            setInvoiceData({
              ...invoiceData,
              terms: e.target.value,
            })
          }
          fullWidth
          variant="outlined"
          placeholder="Terms & Conditions"
          autoComplete="off"
          rows={10}
          multiline
        />
      </div>
    </div>
  );
};

export default SectionTab3;
